import { Component } from '@angular/core';

@Component({
  selector: 'app-questionnaire-unavailable',
  templateUrl: './questionnaire-unavailable.component.html',
  standalone: false,
})
export class QuestionnaireUnavailableComponent {}
